import * as sdkclaro from '@claro/sdkclaromicrofront';
import { getCommissionValues } from "../../components/organisms/GenericForm/utils/getCommissionValues"
import { ClaroSDKService } from "../sdk/ClaroSDKService"

let lastControllerGetCommissions = null;

export const ClaroPayApi = {
    async getCommissionInfo(
        serviceId,
        merchantId,
        amount,
        isClaroPay,
        cardId,
        sdkVersion,
        isClaroPartner,
        trackId,
        userInfo,
        referenceMsisdn,
        isContainerTelcel
    ) {
        // Si existe una solicitud anterior, la cancelamos
        if (lastControllerGetCommissions) {
            lastControllerGetCommissions.abort('Previous request aborted');
        }
        
        // Crear un nuevo AbortController para la nueva solicitud
        lastControllerGetCommissions = new AbortController();
        const { signal } = lastControllerGetCommissions;

        return new Promise((resolve, reject) => {
            try {
                const url = !isContainerTelcel
                    ? "https://apps.claropay.com:11616/prod-CalculadoraComisiones/commissions/calculateCommission"
                    : "https://appstelcel.claropay.com/prod-calccomision/commissions/calculateCommission";
                
                const apikey = !isContainerTelcel
                    ? "DgZNQ7eYRj1LU9THB6z7g1V4pUXSJRXuaMmvJYiR"
                    : "B0rTJiv1Mtwb2KtBhueuIcUqXJWXQzf2Opc38uhp";

                const appVersion = (sdkVersion)?"3.14": "2.0.148";
                const data = {
                    serviceId: serviceId,
                    merchantId: merchantId,
                    amount: amount,
                    isClaroPay : isClaroPay,
                    cardId: cardId,
                    appVersion : appVersion,
                    isClaroPartner : isClaroPartner,
                    referenceMsisdn : referenceMsisdn ? referenceMsisdn : userInfo.msisdn ? userInfo.msisdn.slice(-10) : null,
                };

                ClaroSDKService.postTrack(trackId, 'CCM01-REQUEST', '', {...data, url}, userInfo)
                fetch(url, {
                    signal,
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'x-api-key': apikey
                    },
                    body: JSON.stringify(data)
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(resp) {
                    ClaroSDKService.postTrack(trackId, 'CCM02-RESPONSE', resp, {...data, url}, userInfo)
                    if(resp.responseStatus.desc == "Successful"){
                        console.log(resp.data.serviceCommission, "result commissions success");
                        const result = getCommissionValues(resp.data.serviceCommission);
                        return resolve(result);
                    }
                })
                .catch(function(err) {
                    console.error(err);
                });
            } catch (error) {
                console.log(error, "commisionValues catch");
            }
        })
    },

    async getPlans(serviceId, planType, isContainerTelcel){
        return new Promise((resolve, reject) => {
            try {
                const url = !isContainerTelcel
                    ? `https://apps.claropay.com:11616/prod-appservices/plans/getPlans?idCategory=${planType}&idService=${serviceId}`
                    : `https://appstelcel.claropay.com/prod-appservices/plans/getPlans?idCategory=${planType}&idService=${serviceId}`;

                const apikey = !isContainerTelcel
                    ? "rOZMzIvwnW9HdjaZcRJO1alY7JX5tg0V5d6rjNR3"
                    : "M56eVYkEHa7I8IspW5rYUKwnVZ6s32YYaXKWeta4";

                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'x-api-key': apikey
                    },
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log("Succes plans telcel");
                    return resolve(data.data[0]);
                })
                .catch(function(err) {
                    console.error(err);
                });
            } catch (error) {
                console.log(error, "commisionValues catch");
            }
        })
    },
    async getTelcelLineInformationService(line, claroId){
        return new Promise((resolve, reject) => {
            try {
                fetch(
                    `${process.env.REACT_APP_MIDDLEWARE_TELCEL_URL_API}/?claroid=${claroId}&msisdn=${line}`, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': '*/*',
                            'x-api-key': process.env.REACT_APP_MIDDLEWARE_TELCEL_API_KEY_NAME
                        },
                    }
                )
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log("Midelware telcel success");
                    return resolve(data.data);
                })
                .catch(function(err) {
                    console.log(err , "Midelware telcel error");
                });
            } catch (error) {
                console.log(error, "Midelware telcel catch");
            }
        })
    },

    async getScheduleTelcelBillPaymentContractService(
        bank,
        maximumAmount,
        minimumAmount,
        msisdn,
        periodicity,
        product,
        providerService
    ) {
        let url = process.env.REACT_APP_DOMICILIATION_API_URL;
        url += `/getTemplateTermsConditions`
        url += `?bank=${bank}`;
        url += `&maximumAmount=${maximumAmount}`;
        url += `&minimumAmount=${minimumAmount}`;
        url += `&msisdn=${msisdn}`;
        url += `&periodicity=${periodicity}`;
        url += `&product=${product}`;
        url += `&providerService=${providerService}`;

        return new Promise((resolve, reject) => {
            try {
                fetch(url, 
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': '*/*',
                            'x-api-key': process.env.REACT_APP_DOMICILIATION_API_KEY
                        },
                    }
                )
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    console.log("Schedule bill payment telcel success");
                    return resolve(data.data);
                })
                .catch(function(err) {
                    console.log(err , "Schedule bill payment telcel error");
                });
            } catch (error) {
                console.log(error, "Schedule bill payment telcel catch");
            }
        })
    },

    async getAppSyncApi(bundleVersion) {
        const {
            REACT_APP_APPSYNC_BUNDLE_VERSION_CLARO_PAY,
            REACT_APP_APPSYNC_BUNDLE_ID_CLARO_PAY,
            REACT_APP_APPSYNC_COUNTRY_ID,
            REACT_APP_APPSYNC_BANK_ID
        } = process.env
        bundleVersion = bundleVersion 
            ? bundleVersion 
            : REACT_APP_APPSYNC_BUNDLE_VERSION_CLARO_PAY;
        return new Promise((resolve, reject) => {
          try {
            let url = `${process.env.REACT_APP_SYNC_URL}`;
                    url+= `/appsync/init?bundleID=${REACT_APP_APPSYNC_BUNDLE_ID_CLARO_PAY}`;
                    url+= `&countryId=${REACT_APP_APPSYNC_COUNTRY_ID}`;
                    url+= `&bankId=${REACT_APP_APPSYNC_BANK_ID}`;
                    url+= `&bundleVersion=${bundleVersion}`;
            fetch(url, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (resp) {
                console.log(resp, "response appsync success ");
                resolve(resp);
              })
              .catch(function (error) {
                console.log(error, "appsync error");
              });
          } catch (error) {
            console.log(error, "appsync catch");
          }
        });
    },

    async getAppSyncTelcelApi(bundleVersion) {
        bundleVersion = bundleVersion 
            ? bundleVersion 
            : process.env.REACT_APP_APPSYNC_BUNDLE_VERSION;
            
        return new Promise((resolve, reject) => {
            try {
                let url = `${process.env.REACT_APP_SDK_API_APPSYNC}`;
                    url+= `/appsync/init?bundleID=${process.env.REACT_APP_APPSYNC_BUNDLE_ID}`;
                    url+= `&countryId=${process.env.REACT_APP_APPSYNC_COUNTRY_ID}`;
                    url+= `&bankId=${process.env.REACT_APP_APPSYNC_BANK_ID}`;
                    url+= `&bundleVersion=${bundleVersion}`;

                fetch(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        'Accept': "application/json",
                        'x-api-key': process.env.REACT_APP_SDK_API_KEY_APPSYNC
                    },
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resp) {
                    console.log("response appsync telcel success ");
                    resolve(resp);
                })
                .catch(function (error) {
                    console.log(error, "appsync telcel error");
                });
            } catch (error) {
            console.log(error, "appsync telcel catch");
            }
        });
    },

    async deleteAllCardsApi(userInfo, fullToken) {
        return new Promise(() => {
            try {
                const data = {
                    appVersion: "3.4.100",
                    externalId: "38888a9d-5d9e-4392-a057-829ee92test11",
                    latitude: "0.0",
                    longitude: "0.0",
                    msisdn: userInfo.msisdn,
                    claroId: userInfo.username
                };
                fetch(process.env.REACT_APP_DELETE_ALL_CARDS_URL, {
                    method: 'POST',
                    headers: {
                        'Authorization': `${fullToken.token_type} ${fullToken.access_token}`,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(data)
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(resp) {
                    console.log('Delete all cards success:', resp);
                })
                .catch(function(err) {
                    console.error('Delete all cards error:', err);
                });
            } catch (error) {
                console.log(error, 'Delete all cards catch')
            }  
        })
         
    }
}